var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgOffline = function SvgOffline(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "offline_svg__Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".offline_svg__st0{fill:#ee741d}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "offline_svg__Gruppe_3253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "offline_svg__Pfad_593",
    d: "M256 140c-67.4-.2-132.2 26.6-179.7 74.3l24.6 24.6c85.7-85.5 224.5-85.5 310.2 0l24.6-24.6C388.2 166.5 323.4 139.7 256 140",
    className: "offline_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "offline_svg__Pfad_594",
    d: "M256 203.3c-50.6-.2-99.2 19.9-135 55.8l24.6 24.6c61-60.8 159.7-60.8 220.6 0l24.6-24.6c-35.6-35.9-84.2-56-134.8-55.8",
    className: "offline_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "offline_svg__Pfad_595",
    d: "m165.8 303.9 24.6 24.6c36.2-36.1 94.9-36.1 131.1 0l24.6-24.6c-49.8-49.7-130.4-49.7-180.3 0",
    className: "offline_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "offline_svg__Pfad_596",
    d: "M301.4 348.6 256 394l-45.5-45.5c25.2-25 65.8-25 90.9.1",
    className: "offline_svg__st0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "offline_svg__Pfad_597",
    d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0M46 256c0-68.5 33.4-132.7 89.6-172L336 450.1c-25.4 10.5-52.6 15.8-80 15.8C140 466 46 372 46 256m330.4 172L176 61.9C201.4 51.4 228.5 46 256 46c116 0 209.9 94 209.9 210 .1 68.5-33.3 132.7-89.5 172",
    style: {
      fill: "#64849f"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOffline);
export default ForwardRef;